import _Promise from '/var/www/html/node_modules/babel-runtime/core-js/promise';
import _regeneratorRuntime from '/var/www/html/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/var/www/html/node_modules/babel-runtime/helpers/asyncToGenerator';
import _JSON$stringify from '/var/www/html/node_modules/babel-runtime/core-js/json/stringify';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { load } from 'recaptcha-v3';
import axios from 'axios';
import CheckoutStaticPartial from '~/components/CheckoutStaticPartial.vue';
import $ from 'jquery';
import { loadScript } from "@paypal/paypal-js";

export default {
  layout: function layout(context) {
    return global.getTheme();
  },

  components: {
    'checkout-static-partial': CheckoutStaticPartial
  },
  data: function data() {
    return {
      loading: false,
      viewCVVHelp: false,
      url: null,
      brick: {},
      //paymentMethod: 'credit_card',
      //paymentMethod: 'payguru',
      paymentMethod: '',
      email: '',
      cardholder_name: '',
      card_number: '',
      card_cvv: '',
      card_expiry_month: '',
      card_expiry_year: '',
      card_zipcode: '',
      lastSearchText: '',
      lastSearchType: '',
      paymentPackage: {},
      paymentPackageSettings: {},
      displayCurrency: '',
      stripeToken: null,
      agreementBelowButton: false,
      checkoutAgreement: '',
      ccFormStatus: true,
      ppFormStatus: false,
      checkoutAgreementNoDeposit: '',
      designExp: '',
      emailExp: '',
      paypal: false,
      priceDesignExp: '',
      recaptchaToken: '',
      showpaymentHint: false,
      view: 'default',
      paypalPlan: '',
      paypalClientId: ''
    };
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    global.getPayPalStatus().then(function (value) {
      _this.paypal = value;
    });
    global.getPaypalClientId().then(function (value) {
      _this.paypalClientId = value;
    });
  },
  created: function created() {
    var _this2 = this;

    this.view = global.getTheme();
    if (process.client) {
      this.showpaymentHint = document.location.hostname.replace('www.', '').replace('.com', '') == 'peopleinspect';
    }
    this.designExp = global.signupNewDesignExp;
    this.emailExp = global.signupEmailExp;
    this.priceDesignExp = global.priceNewDesignExp;
    if (process.client && window.location.host == 'www.hawwiyah.com') {
      window.location.href = global.getEndPoint() + this.lang + '/switch-payment';
      return;
    }
    global.getPaymentMethodId().then(function (value) {
      _this2.paymentMethod = value;
      if (process.client && _this2.$auth.isAuthenticated()) {
        _this2.$router.push({ name: 'lang', params: { lang: _this2.lang } });
      }
      if (process.client) {
        _this2.lastSearchText = customSessionStorage.getItem('lastSearchText');
        _this2.lastSearchType = customSessionStorage.getItem('lastSearchType');
      }

      if (_this2.paymentMethod == 'tpay') {
        _this2.tpayPayment();
      } else if (_this2.paymentMethod == 'authorize.net') {
        _this2.authorizeNet();
      } else if (_this2.paymentMethod === 'paymentwall') {
        _this2.paymentWall();
      } else if (_this2.paymentMethod == 'stripe') {
        _this2.stripe();
      } else if (_this2.paymentMethod == 'payguru') {
        _this2.payguruPayment();
      }
      console.log('paypal status is ' + _this2.paypal);
      if (_this2.paypal) {
        _this2.paypalRender();
      }
      _this2.agreementBelowButton = global.agreementBelowButton;
      //this.checkoutAgreement = this.$root.trans('st_public.search_history_is_private', {searchtext: "this.paymentPackageSettings.display_price"});
      //this.checkoutAgreement = this.$root.trans('st_public.checkout_agreement', {price: this.paymentPackageSettings.display_price, currency: this.displayCurrency, websitename: this.websiteName });
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    global.getPaymentMethodId().then(function (value) {
      if (value === 'paymentwall' || value === 'stripe') {
        // -- no direct token generation -- //Stripe.setPublishableKey(global.websiteSettings.config.STRIPE_PUBLISHABLE_KEY );//'pk_test_Z0yLEpUeEVFtTMLX2V1eaPNg');
        //ssthis.initStripeForm();

        if (process.client) {
          if (_this3.lang == 'en') {
            $('.checkout-agreement').css('font-size', '70%');
          }
        }
        if (value === 'paymentwall') {
          _this3.brick = new Brick({
            public_key: global.websiteSettings.config.PAYMENTWALL_PROJECT_KEY,
            form: { formatter: true }
          }, 'custom');
        }
      }
    });
    if (this.$route.query.massage) {
      $(".msg>span").text(this.$root.trans('st_public.' + this.$route.query.massage.replace(/[^a-z0-9 \.+_\-]/ig, '')));
      $(".msg").show();
    }
    this.initRecaptcha();
  },

  computed: {
    lang: function lang() {
      return this.$root._route.params.lang;
    },

    websiteName: function websiteName() {
      var displayName = global.websiteSettings.extra_info.display_name;
      if (displayName) {
        return this.$root.trans('st_public.' + displayName);
      }
      return '';
    }
  },
  head: function head() {
    return {
      titleTemplate: this.getTitle(),
      meta: [{ hid: 'description', name: 'description', content: this.getDescription() }, { hid: 'keywords', name: 'keywords', content: this.getKeywords() }, { hid: 'og:description', name: 'og:description', content: this.getDescription() }, { hid: 'og:title', name: 'og:title', content: this.getTitle() }]
    };
  },

  methods: {
    initRecaptcha: function initRecaptcha() {
      var _this4 = this;

      if (global.websiteSettings.config.recaptcha_key) {
        load(global.websiteSettings.config.recaptcha_key).then(function (recaptcha) {
          recaptcha.execute('creditCard').then(function (token) {
            _this4.recaptchaToken = token;
          });
        });
      }
    },
    selectPaymentMethodForm: function selectPaymentMethodForm(event) {
      var typeForm = event.target.value;
      this.ccFormStatus = typeForm == 'cc-option';
    },
    paypalRender: function paypalRender() {
      var vm = this;
      axios.get(global.getEndPoint() + 'api/paypal/plan/paypal').then(function (res) {

        loadScript({ "client-id": vm.paypalClientId + '&vault=true&intent=subscription&disable-funding=credit,card' }).then(function (paypal) {
          paypal.Buttons({
            style: {
              layout: 'vertical',
              color: 'blue',
              shape: 'rect',
              label: 'paypal',
              size: 'responsive'
            },
            createSubscription: function createSubscription(data, actions) {
              return actions.subscription.create({
                /* Creates the subscription */
                plan_id: res.data.plan,
                quantity: 1 // The quantity of the product for a subscription
              });
            },
            onApprove: function onApprove(data, actions) {
              axios.post(global.getEndPoint() + '/api/paypal/subscription', data).then(function (res) {
                vm.$auth.setToken(res.data.access_token, res.data.refresh_token, res.data.token_type, res.data.expires_in);
                vm.$parent.$emit('login-logout-event');
                vm.$router.push({ name: 'lang-set-password', params: { lang: vm.lang } });
              });
            }
          }).render("#paypal-button-container").catch(function (error) {
            console.error("failed to render the PayPal Buttons", error);
          });
        }).catch(function (error) {
          console.error("failed to load the PayPal JS SDK script", error);
        });
      });
    },
    showPaymentForm: function showPaymentForm() {
      var paymentMethodSupport = ['authorize.net', 'stripe', 'paymentwall'];
      return paymentMethodSupport.includes(this.paymentMethod.toLowerCase());
    },
    getTitle: function getTitle() {
      return this.$root.trans('st_public.signup', this.$root._route.params.lang) + ' - ' + this.$root.trans(global.websiteSettings.extra_info.title);
    },
    getDescription: function getDescription() {
      return this.$root.trans('st_public.signup_meta_description', { website: this.$root.trans(global.websiteSettings.extra_info.title) });
    },
    getKeywords: function getKeywords() {
      return this.$root.trans(global.websiteSettings.extra_info.title) + ', ' + this.$root.trans('st_public.signup', this.$root._route.params.lang);
    },
    toIndiaDigits: function toIndiaDigits(str) {
      if (str == undefined) return '';
      if (this.lang != 'ar') return str;
      var id = ['۰', '۱', '۲', '۳', '٤', '٥', '٦', '۷', '۸', '۹'];
      str = String(str).replace('.', ',');
      return String(str).replace(/[0-9]/g, function (w) {
        return id[+w];
      });
    },
    bindCheckoutAgreement: function bindCheckoutAgreement() {
      this.checkoutAgreement = this.$root.trans('st_public.checkout_agreement', {
        price: this.toIndiaDigits(this.paymentPackageSettings.display_price),
        currency: this.displayCurrency, websitename: this.websiteName
      });
      this.checkoutAgreementNoDeposit = this.$root.trans('st_public.checkout_agreement_checkout_agreement_no_deposit', {
        price: this.toIndiaDigits(this.paymentPackageSettings.display_price),
        currency: this.displayCurrency, websitename: this.websiteName
      });
    },
    payguruPayment: function payguruPayment() {
      var _this5 = this;

      if (process.client) {
        axios.get(global.getEndPoint() + 'api/payment/package/payguru').then(function (res) {
          window.location.href = res.data.url;
          _this5.loading = false;
        });
      }
    },
    tpayPayment: function tpayPayment() {
      var _this6 = this;

      if (process.client) {
        axios.get(global.getEndPoint() + 'api/payment/package/tpay' /*, {headers: {'X-Cookie': this.getAllCookies()}}*/).then(function (res) {
          window.location.href = res.data.url;
          _this6.loading = false;
        });
      }
    },
    paymentWall: function paymentWall() {
      var _this7 = this;

      axios.get(global.getEndPoint() + 'api/payment/package/paymentwall').then(function (res) {
        if (res.data) {
          _this7.loading = false;
          _this7.paymentPackage = res.data ? res.data : {};
          _this7.paymentPackageSettings = _this7.paymentPackage.settings ? _this7.paymentPackage.settings : {};
          _this7.displayCurrency = _this7.$root.trans('st_public.' + _this7.paymentPackageSettings.display_currency);
          _this7.bindCheckoutAgreement();
        }
      });
    },
    authorizeNet: function authorizeNet() {
      var _this8 = this;

      axios.get(global.getEndPoint() + 'api/payment/package/authorize.net').then(function (res) {
        if (res.data) {
          _this8.paymentPackage = res.data ? res.data : {};
          _this8.paymentPackageSettings = _this8.paymentPackage.settings ? _this8.paymentPackage.settings : {};
          _this8.displayCurrency = _this8.$root.trans('st_public.' + _this8.paymentPackageSettings.display_currency);
          _this8.bindCheckoutAgreement();
        }
      });
    },
    stripe: function stripe() {
      var _this9 = this;

      axios.get(global.getEndPoint() + 'api/payment/package/stripe').then(function (res) {
        if (res.data) {
          _this9.paymentPackage = res.data ? res.data : {};
          _this9.paymentPackageSettings = _this9.paymentPackage.settings ? _this9.paymentPackage.settings : {};
          _this9.displayCurrency = _this9.$root.trans('st_public.' + _this9.paymentPackageSettings.display_currency);
          _this9.bindCheckoutAgreement();
        }
      });
    },
    getAllCookies: function getAllCookies() {
      if (process.client) {
        return document.cookie;
      }
      return '';
    },
    redirect: function redirect() {
      if (this.lastSearchText && this.lastSearchType) {
        this.$router.push({
          name: 'lang-search-results-type-search-loading',
          params: { lang: this.lang, type: this.lastSearchType, search: this.lastSearchText }
        });
      } else {
        this.$router.push({ name: 'lang', params: { lang: this.lang } });
      }
    },
    showCvvHelp: function showCvvHelp() {
      this.viewCVVHelp = !this.viewCVVHelp;
    },
    creditCard: function creditCard() {
      var _this10 = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this10.loading = true;
          if (_this10.paymentMethod === 'paymentwall') {
            var $form = $('#paymentForm');
            _this10.submitCCFormPaymentWall();
          } else if (_this10.paymentMethod === 'stripe') {
            var $form = $('#paymentForm');
            // Request a token from Stripe:
            // -- no direct token generation -- //Stripe.card.createToken($form, this.stripeResponseHandler);
            _this10.submitCCForm();
          } else {
            _this10.submitCCForm();
          }
          if (typeof ccPaymentAttemptHandler != 'undefined') {
            ccPaymentAttemptHandler();
          }
        }
      });
    },
    ppPayment: function ppPayment() {
      var url = global.getEndPoint() + '/api/paypal/checkout';
      axios.post(url);
    },
    submitCCFormPaymentWall: function submitCCFormPaymentWall() {
      var _this11 = this;

      var nameParts = this.cardholder_name.split(/\s+/);
      if (nameParts.length < 2) {
        this.errors.add('cardholder_name', this.$root.trans('st_public.first and second names are required.'));
        return;
      }

      var requestParams = {};
      requestParams.registration_lang = this.lang;
      requestParams.email = this.email;
      requestParams.card_exp = this.card_expiry_year + '-' + this.card_expiry_month;
      requestParams.first_name = nameParts.shift();
      requestParams.last_name = nameParts.join(' ');
      requestParams.card_cvv = this.card_cvv;
      requestParams.card_zipcode = this.card_zipcode;
      var subscriptionUrl = global.getEndPoint() + 'api/paymentwall/pw-register';
      this.brick.tokenizeCard({ //PaymentWall tokenize payment details
        card_number: this.card_number,
        card_expiration_month: this.card_expiry_month,
        card_expiration_year: this.card_expiry_year,
        card_cvv: this.card_cvv
      }, function (brickTokens) {
        if (brickTokens.type === 'Error') {
          _this11.loading = false;
          $(".msg>span").html(_this11.$root.trans('error in brick tokenizeCard'));
          $(".msg").show();
          var targetDiv = document.querySelector(".alert-danger");
          targetDiv.scrollIntoView({ behavior: "smooth" });
        } else {
          requestParams.token = brickTokens.token;
          requestParams.fingerprint = Brick.getFingerprint();
          axios.post(subscriptionUrl, requestParams).then(function (res) {
            _this11.loading = false;
            var data = JSON.parse(_JSON$stringify(res.data));
            window.location.replace(data);
          }).catch(function (err) {
            _this11.loading = false;
            var errorMessage = err.message;
            if (err.response && err.response.data && err.response.data.message) {
              errorMessage = err.response.data.message;
            }
            if (err.response.data.message) {
              $(".msg>span").html(_this11.$root.trans('st_public.' + errorMessage));
              $(".msg").show();
              var targetDiv = document.querySelector(".alert-danger");
              targetDiv.scrollIntoView({ behavior: "smooth" });
            }

            _this11.errors.clear();
            var errors = err.response.data.errors;
            if (errors) {
              for (var field in errors) {
                _this11.errors.add(field, errors[field].join(', '));
              }
            }
          });
        }
      });
    },
    submitCCForm: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this12 = this;

        var nameParts, requestParams, subscriptionRequestParams, subscriptionUrl;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                nameParts = this.cardholder_name.split(/\s+/);

                if (!(nameParts.length < 2)) {
                  _context2.next = 4;
                  break;
                }

                this.errors.add('cardholder_name', this.$root.trans('st_public.first and second names are required.'));
                return _context2.abrupt('return');

              case 4:
                requestParams = {};

                requestParams.registration_lang = this.lang;
                requestParams.email = this.email;
                requestParams.first_name = nameParts.shift();
                requestParams.last_name = nameParts.join(' ');
                requestParams.name = this.cardholder_name;
                requestParams.card_zipcode = this.card_zipcode;
                requestParams.recaptcha_token = this.recaptchaToken;
                requestParams.card_exp_month = this.card_expiry_month;
                requestParams.card_exp_year = this.card_expiry_year;
                requestParams.card_cvv = this.card_cvv;
                requestParams.card_last_4digits = '';
                if (this.card_number.length > 4) {
                  requestParams.card_last_4digits = this.card_number.substring(this.card_number.length - 4);
                }

                subscriptionRequestParams = {};

                subscriptionRequestParams.submitted_form_hash = '';
                subscriptionUrl = global.getEndPoint() + 'api/stripe/subscription';

                if (!(this.paymentMethod == 'stripe')) {
                  _context2.next = 25;
                  break;
                }

                _context2.next = 23;
                return this.getPciCaptureUrl(requestParams).then(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(captureRes) {
                    var tokenResponse;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            subscriptionRequestParams.submitted_form_hash = captureRes.submitted_form_hash;
                            _context.next = 3;
                            return _this12.createToken(captureRes.url, captureRes.secret).then(function (res) {
                              subscriptionRequestParams.pci_vault_token = res.token;
                              subscriptionRequestParams.reference = res.reference;
                            }).catch(function (error) {
                              _this12.loading = false;
                              $(".msg>span").html('Unexpected Error');
                              $(".msg").show();
                              var targetDiv = document.querySelector(".alert-danger");
                              targetDiv.scrollIntoView({ behavior: "smooth" });
                            });

                          case 3:
                            tokenResponse = _context.sent;

                          case 4:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this12);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  _this12.loading = false;
                  $(".msg>span").html('Unexpected Error');
                  $(".msg").show();
                  var targetDiv = document.querySelector(".alert-danger");
                  targetDiv.scrollIntoView({ behavior: "smooth" });
                });

              case 23:
                if (!(subscriptionRequestParams.submitted_form_hash === '')) {
                  _context2.next = 25;
                  break;
                }

                return _context2.abrupt('return', false);

              case 25:

                axios.post(subscriptionUrl, subscriptionRequestParams /*, {headers: {'X-Cookie': this.getAllCookies()}}*/).then(function (res) {
                  _this12.loading = false;
                  _this12.$auth.setToken(res.data.access_token, res.data.refresh_token, res.data.token_type, res.data.expires_in);
                  _this12.$parent.$emit('login-logout-event');

                  //this.$router.push({name: 'lang-successful-signup', params:{lang: this.lang}});
                  _this12.$router.push({ name: 'lang-set-password', params: { lang: _this12.lang } });
                }).catch(function (err) {
                  _this12.loading = false;
                  if (err.message) {
                    /*if(flash)
                        flash(this.$root.trans('st_public.'+err.response.data.message), 'error');*/
                    //console.log(err.response.data);
                    $(".msg>span").html(_this12.$root.trans('st_public.' + err.response.data.message));
                    $(".msg").show();
                    var targetDiv = document.querySelector(".alert-danger");
                    targetDiv.scrollIntoView({ behavior: "smooth" });
                  }

                  _this12.errors.clear();
                  var errors = err.response.data.errors;
                  if (errors) {
                    for (var field in errors) {
                      _this12.errors.add(field, errors[field].join(', '));
                    }
                  }

                  _this12.initRecaptcha();
                });

              case 26:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function submitCCForm() {
        return _ref.apply(this, arguments);
      }

      return submitCCForm;
    }(),
    stripeResponseHandler: function stripeResponseHandler(status, response) {

      if (response.error) {
        // Show the errors on the form:
        //if(flash) flash(this.$root.trans(response.error.message), 'error');
        $(".msg>span").html(this.$root.trans('st_public.' + response.error.message));
        $(".msg").show();
        this.loading = false;
        var targetDiv = document.querySelector(".alert-danger");
        targetDiv.scrollIntoView({ behavior: "smooth" });
        axios.post(global.getEndPoint() + 'api/stripe/payment_attemp').then(function (res) {});
      } else {

        // Get the token ID:
        var token = response.id;
        // Insert the token ID into the form so it gets submitted to the server:
        this.stripeToken = token;
        // For this demo, we're simply showing the token:
        this.submitCCForm();
      }
    },
    getPciCaptureUrl: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(requestParams) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', new _Promise(function (resolve, reject) {
                  $.ajax({
                    url: global.getEndPoint() + 'api/pciv/get-capture',
                    type: 'POST',
                    data: requestParams,
                    headers: { 'Accept': 'application/json' },
                    dataType: 'json',
                    success: function success(response) {
                      // Handle the success response here
                      resolve(response);
                    },
                    error: function error(xhr, status, _error) {
                      // Handle errors here
                      reject(_error);
                    }
                  });
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getPciCaptureUrl(_x2) {
        return _ref3.apply(this, arguments);
      }

      return getPciCaptureUrl;
    }(),
    createToken: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(captureUrl, secret) {
        var _this13 = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', new _Promise(function (resolve, reject) {
                  $.ajax({
                    url: 'https://api.pcivault.io' + captureUrl,
                    type: 'POST',
                    data: _JSON$stringify({
                      "expiry_year": _this13.card_expiry_year,
                      "expiry_month": _this13.card_expiry_month,
                      "cvv": _this13.card_cvv,
                      "card_holder": _this13.cardholder_name,
                      "card_number": _this13.card_number
                    }),
                    headers: { 'Accept': 'application/json', 'X-PCIVault-Capture-Secret': secret },
                    dataType: 'json',
                    success: function success(response) {
                      // Handle the success response here
                      resolve(response);
                    },
                    error: function error(xhr, status, _error2) {
                      // Handle errors here
                      reject(_error2);
                    }
                  });
                }));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function createToken(_x3, _x4) {
        return _ref4.apply(this, arguments);
      }

      return createToken;
    }()
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/signup.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/signup.vue
// module chunks = 9